import { styles } from './template.scss';
import { styles as commonStyles } from '../../assets/common.scss';
import { styles as flexboxHelpersStyles } from '../../assets/flexbox-helpers.scss';
import { styles as widgetSharedStyles } from '../../assets/widget-shared.scss';
import { ImageState } from '../../ui/gzImageRepo/types';

export const templateEndpointDetails = document.createElement('template');

templateEndpointDetails.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <div>
        <gz-title fontSize="11" fontWeight="600" id="title"> Endpoint Details </gz-title>
        <gz-loader class='loader' rows="4"></gz-loader>
        <gz-image-repo state="${ImageState.ERROR}" class="error">
            <gz-text fontSize="14" fontWeight="400" lineHeight="1.2" id="error-message" />
        </gz-image-repo>
        <div class="details-container">
          <gz-labeled-content hasColon id="name" label="">
            <gz-tooltip tooltiptext="" isellipsis="true" id="name-tooltip" class="d-block">
                <gz-text fontSize="12" class="d-inline" id="name-content"></gz-text>
            </gz-tooltip>
          </gz-labeled-content>
          <gz-labeled-content hasColon id="ip" label="">
            <gz-tooltip tooltiptext="" isellipsis="true" id="ip-tooltip" class="d-block">
                <gz-text fontSize="12" class="d-inline" id="ip-content"></gz-text>
            </gz-tooltip>
          </gz-labeled-content>
          <gz-labeled-content hasColon id="os" label="">
            <gz-tooltip tooltiptext="" isellipsis="true" id="os-tooltip" class="d-block">
                <gz-text fontSize="12" class="d-inline" id="os-content"></gz-text>
            </gz-tooltip>
          </gz-labeled-content>
          <gz-labeled-content hasColon id="label" label="">
            <gz-tooltip tooltiptext="" isellipsis="true" id="label-tooltip" class="d-block">
                <gz-text fontSize="12" class="d-inline" id="label-content"></gz-text>
            </gz-tooltip>
          </gz-labeled-content>
        </div>
    </div>
  </div>
`;
